import UploadStockingDealersCSV from '@/explore/ffl-detail/licenseByZipQuery/uploadStockingDealersCSV'
import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react'

function StockingDealers() {
    const {
        isOpen: stockingIsOpen,
        onOpen: stockingOnOpen,
        onClose: stockingOnClose
    } = useDisclosure();
    return (
        <>
            <Button onClick={stockingOnOpen}>Upload Stocking Dealers</Button>
            {stockingIsOpen && <UploadStockingDealersCSV isOpen={stockingIsOpen} onClose={stockingOnClose} />}
        </>
    )
}

export default StockingDealers